module.exports = __webpack_public_path__ + "static/media/gsNl3i_sm2.0f18d5b2.png";